import { render, staticRenderFns } from "./liftManagementList.vue?vue&type=template&id=32fad361&"
import script from "./liftManagementList.vue?vue&type=script&lang=js&"
export * from "./liftManagementList.vue?vue&type=script&lang=js&"
import style0 from "./liftManagementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports